import jwt from "../middlewares/jwt.js";
import moment from "moment";

const api = new jwt.API();

const i_APC = {
  namespaced: true,
  state: () => ({
    // sensor dashboard
    schedule_light: undefined,
    schedule_breaker: undefined,
    schedule_air: undefined,
    numDevice: [],
    floor: ["1st Floor", "2nd Floor", "3rd Floor", "4th Floor"],

    // RM management
    AllTag: [],
    department: [],
    dept_name: [],
    numWorker: 0,
    numWorkerActive: 0,
  }),
  mutations: {
    schedule_light(state, newValue) {
      state.schedule_light = newValue;
    },
    schedule_breaker(state, newValue) {
      state.schedule_breaker = newValue;
    },
    schedule_air(state, newValue) {
      state.schedule_air = newValue;
    },
    floor(state, newValue) {
      state.floor = newValue;
    },
    numDevice(state, newValue) {
      state.numDevice = newValue;
    },

    // RM management
    AllTag(state, newValue) {
      state.AllTag = newValue;
    },
    department(state, newValue) {
      state.department = newValue;
    },
    dept_name(state, newValue) {
      state.dept_name = newValue;
    },
    numWorker(state, newValue) {
      state.numWorker = newValue;
    },
    numWorkerActive(state, newValue) {
      state.numWorkerActive = newValue;
    },
  },
  actions: {
    genData({ dispatch, commit, getters, rootGetters }) {
      commit(
        "schedule_light",
        Array.from({ length: getters["floor"].length }, (v, i) =>
          Array.from(
            { length: getters["numDevice"][i].light.length },
            (v, i) => []
          )
        )
      );

      commit(
        "schedule_breaker",
        Array.from({ length: getters["floor"].length }, (v, i) =>
          Array.from(
            { length: getters["numDevice"][i].breaker.length },
            (v, i) => []
          )
        )
      );

      commit(
        "schedule_air",
        Array.from({ length: getters["floor"].length }, (v, i) =>
          Array.from(
            { length: getters["numDevice"][i].air.length },
            (v, i) => []
          )
        )
      );
    },
    async getSensor({ dispatch, commit, getters, rootGetters }) {
      commit("numDevice", [
        { light: [], air: [], breaker: [] },
        { light: [], air: [], breaker: [] },
        { light: [], air: [], breaker: [] },
        { light: [], air: [], breaker: [] },
      ]);
      let allsensor = await api.get("sensors/user");
      console.log(allsensor);
      if (allsensor.status == 200 || allsensor.status == 204) {
        for (let j = 0; j < allsensor.data.length; j++) {
          const el = allsensor.data[j];
          let floor = Number(el.serial_id[8]) - 1;
          let num =
            el.serial_id[10] != undefined ? Number(el.serial_id[10]) - 1 : 0;
          // console.log(el, floor, num);

          if (el.subtype == "breaker") {
            floor = Number(el.serial_id[8]) - 1;
            getters["numDevice"][floor][el.subtype].push(el.serial_id);
            if (el.serial_id[10] != undefined) {
              floor = Number(el.serial_id[10]) - 1;
              getters["numDevice"][floor][el.subtype].push(el.serial_id);
            }
          } else if (el.subtype == "light") {
            floor = Number(el.serial_id[6]) - 1;
            getters["numDevice"][floor][el.subtype].push(el.serial_id);
            if (el.serial_id[8] != undefined) {
              floor = Number(el.serial_id[8]) - 1;
              getters["numDevice"][floor][el.subtype].push(el.serial_id);
            }
          } else if (el.subtype == "air") {
            getters["numDevice"][floor][el.subtype].push(el.serial_id);
          }
        }
        console.log(getters["numDevice"]);
      }
    },
    async getSchedule({ dispatch, commit, getters, rootGetters }) {
      let res = await api.get("schedule/v2.0/get/all");
      console.log(res);
      // console.log(getters["schedule_air"]);
      //   console.log(getters["schedule_light"]);
      if (res.status == 200 || res.status == 204) {
        for (let i = 0; i < res.data.length; i++) {
          const el = res.data[i];
          //   console.log(el.device_id[8]);
          let floor = Number(el.device_id[8]) - 1;
          let num =
            el.device_id[10] != undefined ? Number(el.device_id[10]) - 1 : 0;
          // console.log(floor, num);

          // map data
          let schedule = {
            name: el.name,
            timeOpen: el.start_time,
            timeClose: el.end_time,
            on: el.active,
            device_id: el.device_id,
            id: el.id,
            temperature:
              el.mode == "air"
                ? {
                    state: el.temp ? true : false,
                    temp: el.temp == null ? 25 : el.temp,
                  }
                : undefined,
            week: {
              Su: el.date_list[0],
              Mo: el.date_list[1],
              Tu: el.date_list[2],
              We: el.date_list[3],
              Th: el.date_list[4],
              Fr: el.date_list[5],
              Sa: el.date_list[6],
            },
          };
          // console.log(getters["schedule_air"]);
          if (el.mode == "air") {
            getters["schedule_air"][floor][num].push(schedule);
            // commit.schedule_air[floor][num].push(schedule);
          } else if (el.mode == "light") {
            // console.log(el.device_id.split("_")[0]);
            if (el.device_id.split("_")[0] == "light") {
              floor = Number(el.device_id[6]) - 1;
              num = 0;
              getters["schedule_light"][floor][num].push(schedule);
            } else {
              num = 0;
              getters["schedule_breaker"][floor][num].push(schedule);
            }

            // commit.schedule_light[floor][num].push(schedule);
          }
        }
        // console.log(getters["schedule_air"]);
        // console.log(getters["schedule_light"]);
      }
    },

    // RM management
    async getTagInfo({ dispatch, commit, getters, rootGetters }) {
      let numWorker = 0,
        numActive = 0;
      let department = [];
      let allTag = [];
      let dept_name = [];
      // console.log(getters["department"],getters["department2"]);
      let today = moment().format("YYYY-MM-DD");
      console.log(today);
      let res = await api.get("iAPC/getinfo/current");
      if (res.status == 200) {
        console.log(res.data);
        allTag = res.data;
        for (let i = 0; i < res.data.length; i++) {
          let el = res.data[i];
          console.log(el.name,el.status,el.timecount);
          el.status =
              el.timestamp != null
                ? el.timestamp.split("T")[0] == today
                  ? el.status
                  : null
                : null;

          // find num of department
          if (
            dept_name.indexOf(el.dept) == -1 &&
            el.dept != null &&
            el.dept != ""
          ) {
            dept_name.push(el.dept);
            department.push([]);
          }

          el.name = el.name == null ? '': el.name;
          // push tag have department and name
          if (
            el.name != null &&
            el.name != "" &&
            dept_name.indexOf(el.dept) != -1
          ) {
            // console.log(dept_name.indexOf(el.dept));
            // el.status =
            //   el.timestamp != null
            //     ? el.timestamp.split("T")[0] == today
            //       ? el.status
            //       : null
            //     : null;
            el.timecount = Math.round((el.timecount * 100.0) / 3600) / 100;
            let index = dept_name.indexOf(el.dept);
            department[index].push(el);

            // count worker present
            if (el.status != null) {
              numWorker++;
            }
            // count worker on site
            if (el.status == "in") {
              numActive++;
            }
          }
        }
        console.log(dept_name, getters["department"]);
        // for (let i = 0; i < res.data.length; i++) {
        //   const el = res.data[i];
        //   if (el.name != null && el.name != "") {
        //     if ((department.length + department2.length) % 2 == 0) {
        //       department.push(el);
        //       // getters["department"].push(el);
        //     } else {
        //       department2.push(el);

        //       // getters["department2"].push(el);
        //     }

        //     if (el.status != null) {
        //       numWorker++;
        //     }
        //     if (el.status == "in") {
        //       numActive++;
        //     }
        //   }
        // }
        commit("numWorker", numWorker);
        commit("numWorkerActive", numActive);
        commit("AllTag", allTag);
        commit("department", department);
        commit("dept_name", dept_name);
      }
      // console.log(this.listTag);
      // console.log(getters["department"], getters["department2"]);
    },
    // not use
    async updateTagInfo({ dispatch, commit, getters, rootGetters }) {
      let res = await api.get("iAPC/getinfo/current");
      let numWorker = 0,
        numActive = 0;
      let department = [],
        department2 = [];
      if (res.status == 200) {
        console.log(res.data[0]);
        console.log(getters["department"]);
        for (let i = 0; i < res.data.length; i++) {
          const el = res.data[i];
          if (el.name != null) {
            for (let j = 0; j < getters["department"].length; j++) {
              const ellistTag = getters["department"][j];
              // console.log(getters["department"]);

              if (el.tag == ellistTag.tag) {
                commit("departmentItem", { i: j, newValue: el });

                break;
              }
            }
            for (let j = 0; j < getters["department2"].length; j++) {
              const ellistTag = getters["department2"][j];
              // console.log(getters["department2"]);

              if (el.tag == ellistTag.tag) {
                commit("department2Item", { i: j, newValue: el });

                break;
              }
            }

            if (el.status != null) {
              numWorker++;
            } else if (el.status == "in") {
              numActive++;
            }
          }
        }
        commit("numWorker", numWorker);
        commit("numWorkerActive", numActive);
      }
    },
  },
  getters: {
    schedule_light(state) {
      return state.schedule_light;
    },
    schedule_breaker(state) {
      return state.schedule_breaker;
    },
    schedule_air(state) {
      return state.schedule_air;
    },
    floor(state) {
      return state.floor;
    },
    numDevice(state) {
      return state.numDevice;
    },

    // RM management
    AllTag(state) {
      return state.AllTag;
    },
    department(state) {
      return state.department;
    },
    dept_name(state) {
      return state.dept_name;
    },
    numWorker(state) {
      return state.numWorker;
    },
    numWorkerActive(state) {
      return state.numWorkerActive;
    },
  },
};

export default i_APC;
